<template>
  <div
    :class="[
      'text-field',
      invalid && 'text-field_error',
      theme && `text-field_theme_${theme}`,
      withClear && `text-field_with-clear`,
    ]"
  >
    <input
      class="text-field__control"
      :id="id"
      v-model.trim="model"
      :placeholder="placeholder"
      :disabled="disabled"
      :required="required"
      :readonly="readonly"
      type="text"
    />
    <span v-if="withClear" class="text-field__clear" id="text-field-clear" @click="clear">
      <slot name="clear-icon">
        <font-awesome-icon :icon="['far', 'times']" />
      </slot>
    </span>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import FormField from '@/mixins/FormField';

export default {
  name: 'TextField',

  components: {
    FontAwesomeIcon,
  },

  mixins: [FormField],
};
</script>

<style lang="scss" scoped>
@import '~styles/tools/variables';

@mixin placeholder {
  font-size: 14px;
  font-weight: 200;
  color: #bfbfbf;
}

.text-field {
  display: block;
  position: relative;

  &__control {
    font-size: 16px;
    height: 40px;
    width: 100%;
    padding: 0 10px;
    color: #4a4a4a;
    border: 1px solid $default-text-grey;
    border-radius: 4px;
    box-sizing: border-box;
    transition: border-color 0.25s, color 0.25s;

    &:focus,
    &:hover {
      border-color: $default-blue;
    }

    &::-webkit-input-placeholder {
      @include placeholder;
    }

    &:-ms-input-placeholder {
      @include placeholder;
    }

    &::-ms-input-placeholder {
      @include placeholder;
    }

    .text-field_theme_dark & {
      color: white;
      background: $default-component-grey;
      border-color: transparent;
    }

    .text-field_error & {
      border-color: $error-red;
    }

    .text-field_with-clear & {
      padding-right: 32px;
    }

    &[disabled] {
      background: #414141;
    }
  }

  &__clear {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    opacity: 0.75;

    &:hover {
      cursor: pointer;
      opacity: 1;
    }
  }
}
</style>
